import React, { Component, Fragment } from "react";
import { Button, Col, Dropdown, FormLabel, Image, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
import { connect } from "react-redux";
import ImgFilter from "../../../../assets/images/icon-filter.svg";
import ImgListView from "../../../../assets/images/icon-list-view.svg";
import ImgLocation from "../../../../assets/images/icon-location-pin.svg";
import Checkbox from "../../../../components/UI/Checkbox/Checkbox";
import Input from "../../../../components/UI/Input/Input";
import ProviderMaps from "../../../../components/UI/ProviderMaps/ProviderMaps";
import Select from "../../../../components/UI/SelectOption/SelectOption";
import Spinner from "../../../../components/UI/Spinner/Spinner";
import errorMessages from "../../../../errorMessages";
import { logFirebaseEvent } from "../../../../shared/utility";
import * as findProviderActions from "../../../../store/actions/";
import ProviderDetails from "../../ProviderDetails/ProviderDetails";
import FindProviderResult from "../../Result/FindProviderResult";
import FindProviderSearch from "../FindProviderSearch/FindProviderSearch";
import classes from "./FindProvider.module.css";

interface IStatefromProps {
  error: boolean;
  loading: boolean;
  errorMessage: string;
  providers: {
    providerId: string;
    providerName: string;
    providerEntityType: string;
    providerLabels: string[];
    longitude: number;
    latitude: number;
    address: string;
    city: string;
    state: string;
    hospitalName: string;
    postalCode: string;
    phoneNumber: string;
    isNational:boolean;
    providerType: string;
    specialty: string[];
    isContracted: true;
    favoriteId: string;
    isFavorite: boolean;
    isPreferred: boolean;
    isTier: boolean;
    totalExperienceScore: number;
    distance: number;
    gender: string;
    experienceScore: {
      label: string;
      value: number;
    }[];
    quantrosScores: {
      category: string;
      scores: { name: string; order: number; score: number }[];
    }[];
    providerTypeId: number;
    specialtyId: number;
    medicareValue: number;
    npi: string;
    orgDistance: string;
    orgPostalCode: string;
    isMore: boolean;
    finderLabel:string;
    additionalLocationsCount: number;
  }[];
  params: {
    distance: number;
    longitude: string;
    latitude: string;
    postalCode: string;
    providerName: string;
    providerType: string;
    specialty: string;
    scoreHigherThan: number;
    scoreLowerThan: number;
    isContracted: boolean;
    isFavorite: boolean;
    isPreferred: boolean;
    isTier: boolean;
    gender: string;
    fetchCurrentLocation: boolean;
    location: string;
    limit: string;
    currentAttempt: number;
    extendedDistance: number;
    isMore: boolean;
  };
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  t: any;
}
interface IDispatchFromProps {
  onFetchProviders: (searchParams: {}) => void;
  onAddSearchParam: (name: string, value: string | number | boolean) => void;
  onResetUnFavoriteProvider: () => void;
  onResetFavoriteProvider: () => void;
}

type Props = IStatefromProps & IDispatchFromProps;
class FindProvider extends Component<Props> {
  state = {
    mapView: false,
    cardView: true,
    searchView: true,
    detailView: false,
    providerIdClicked: "",
    providerTypeId: 0,
    specialtyId: 0,
    npi: "",
    distance: 0,
    postalCode: "",
    orgDistance: "",
    providerScore: 4,
    changeBy: 1,
    providerName: this.props.params.providerName,
    isFavorite: this.props.params.isFavorite,
    isPreferred: this.props.params.isPreferred,
    isTier: this.props.params.isTier,
    isContracted: this.props.params.isContracted,
    gender: this.props.params.gender,
    value: {
      min: this.props.params.scoreHigherThan,
      max: this.props.params.scoreLowerThan,
    },
    isMore: this.props.params.isMore,
    contractStatus: ''
  };
  detailViewHandler = () => {
    console.log("detailViewHandler");
    this.setState({ detailView: false });
    this.setState({ searchView: true });
  };
  showMapView = () => {
    this.setState({ mapView: true });
    this.setState({ cardView: false });
    logFirebaseEvent("MapView");
  };
  showCardView = () => {
    this.setState({ mapView: false });
    this.setState({ cardView: true });
  };
  resultViewHandler = (
    providerId: string,
    npi: string,
    distance: number,
    postalCode: string,
    orgDistance: string
  ) => {
    console.log("resultViewHandler", providerId);
    this.setState({ providerIdClicked: providerId });
    // this.setState({ providerTypeId: providerTypeId });
    // this.setState({ specialtyId: specialtyId });
    this.setState({ npi: npi });
    this.setState({ distance: distance });
    this.setState({ postalCode: postalCode });
    this.setState({ orgDistance: orgDistance });
    this.setState({});
    this.setState({ detailView: true });
    this.setState({ searchView: false });
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    this.props.onAddSearchParam(e.target.name, e.target.value);
  };
  handleGenderChange = (e) => {
    console.log(`handleGenderChange`, e.target.value);
    let genderVal =
      e.target.value === "Male" || e.target.value === "hombre"
        ? "M"
        : e.target.value === "Female" || e.target.value === "mujer"
        ? "F"
        : "Gender";
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(`genderVal---`, genderVal);

    this.props.onAddSearchParam(e.target.name, genderVal);
  };
  handleFavoriteChecked = () => {
    this.props.onAddSearchParam("isFavorite", !this.state.isFavorite);
    // this.setState({ isFavorite: !this.state.isFavorite });
  };
  handlePreferredChecked = () => {
    this.props.onAddSearchParam("isPreferred", !this.state.isPreferred);
    // this.setState({ isFavorite: !this.state.isFavorite });
  };
  handleTierChecked = () => {
    this.props.onAddSearchParam("isTier", !this.state.isTier);
    // this.setState({ isFavorite: !this.state.isFavorite });
  };
  handleContractedChecked = () => {
    this.props.onAddSearchParam("isContracted", !this.state.isContracted);
    // this.setState({ isContracted: !this.state.isContracted });
  };
  handleScore = (value) => {
    this.setState({ value: value });
    this.props.onAddSearchParam("scoreHigherThan", value.min);
    this.props.onAddSearchParam("scoreLowerThan", value.max);
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onAddSearchParam("currentAttempt", 0);
    console.log(this.props.params);
    if (
      this.props.params.isContracted ||
      this.props.params.scoreLowerThan < 10 ||
      this.props.params.scoreHigherThan > 0 ||
      this.props.params.gender !== "Gender"
    ) {
      this.props.onAddSearchParam("isMore", true);
    } else {
      this.props.onAddSearchParam("isMore", false);
    }
    // this.props.onFetchProviders(this.props.params);
  };
  componentDidMount() {
    logFirebaseEvent("FindProvider");
    if (this.props.params.currentAttempt !== -1) {
      this.props.onFetchProviders(this.props.params);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.params.currentAttempt === 0) {
      this.props.onAddSearchParam("currentAttempt", 1);
    }
    if (
      prevProps.params.currentAttempt !== this.props.params.currentAttempt &&
      (this.props.params.currentAttempt === 2 ||
        this.props.params.currentAttempt === 1)
    ) {
      this.props.onFetchProviders(this.props.params);
    } else if (
      this.props.providers.length <= 0 &&
      this.props.params.currentAttempt === 1 &&
      !this.props.loading
    ) {
      console.log("this.props.params", this.props.params);
      if (this.props.params.isContracted) {
        this.props.onAddSearchParam("isContracted", false);
      } else if (this.props.params.scoreLowerThan < 10) {
        this.props.onAddSearchParam("scoreLowerThan", 10);
      } else if (this.props.params.scoreHigherThan > 0) {
        this.props.onAddSearchParam("scoreHigherThan", 0);
      } else if (this.props.params.gender !== "Gender") {
        this.props.onAddSearchParam("gender", "Gender");
      } else if (
        this.props.params.distance < this.props.params.extendedDistance
      ) {
        this.props.onAddSearchParam("currentAttempt", 2);
      }
    }
    if (prevProps.params.isContracted !== this.props.params.isContracted) {
      this.setState({ isContracted: this.props.params.isContracted });
    }
    if (
      prevProps.params.scoreLowerThan !== this.props.params.scoreLowerThan ||
      prevProps.params.scoreHigherThan !== this.props.params.scoreHigherThan
    ) {
      this.setState({
        value: {
          max: this.props.params.scoreLowerThan,
          min: this.props.params.scoreHigherThan,
        },
      });
    }
    if (prevProps.params.gender !== this.props.params.gender) {
      this.setState({ gender: this.props.params.gender });
    }

    if (prevProps.params.isMore !== this.props.params.isMore) {
      this.setState({ isMore: this.props.params.isMore });
    }
  }

  verifyState = () => {
    return (this.props.params.postalCode === null ||
      this.props.params.postalCode === "") &&
      (this.props.params.latitude === null ||
        this.props.params.latitude === "" ||
        this.props.params.longitude === null ||
        this.props.params.longitude === "")
      ? true
      : false;
  };
  render() {
    const { t } = this.props;
    // console.log("this.props.errorMessage", this.props.errorMessage);
    const { providers } = { ...this.props };
    const elementLabelHideStyle = {
      display: "none",
    };
    const elementLabelStyle = {
      fontSize: "12px",
    };
    const elementInputStyle = {
      minHeight: "30px",
      padding: "6px 10px",
      fontSize: "12px",
    };
    /*Dropdrom show and hide based on findprovider view or myfavorites*/
    let dropdown: any;
    dropdown = (
      <Dropdown className={classes.filterMore}>
        <Dropdown.Toggle
          id="dropdown-basic"
          className="btn btn-small btnFilter"
          disabled={this.verifyState()}
        >
          {t("findProviderPage.more")}
          <Image src={ImgFilter} alt="ImgFilter" />
        </Dropdown.Toggle>
        <Dropdown.Menu className={classes.filterDropdown}>
          <div className={classes.mbSpace}>
            <Input
              label=""
              supportLabel=""
              placeholder={t("findProviderPage.providerName")}
              elementLabelStyle={elementLabelHideStyle}
              elementInputStyle={elementInputStyle}
              name="providerName"
              errorText=""
              value={this.props.params["providerName"]}
              onChange={(e) => this.handleChange(e)}
            />
          </div>
          {/* <div className={classes.mbSpace}>
            <Checkbox
              label="Favorites"
              id="Favorites"
              defaultChecked={this.state.isFavorite}
              onChange={this.handleFavoriteChecked}
              name="isFavorite"
            />
          </div> */}
          {/* <div className={classes.mbSpace}>
            <Checkbox
              label={t("findProviderPage.contracted")}
              id="Contracted"
              checked={this.state.isContracted}
              onChange={this.handleContractedChecked}
              name="isContracted"
            />
          </div> */}
          {/* <div className={classes.mbSpace}>
          <Checkbox
              label="Preferred"
              id="Preferred"
              defaultChecked={this.state.isPreferred}
              onChange={this.handlePreferredChecked}
              name="isPreferred"
            />
          </div>
          <div className={classes.mbSpace}>
          <Checkbox
              label="Tier 1"
              id="Tier"
              defaultChecked={this.state.isTier}
              onChange={this.handleTierChecked}
              name="isTier"
            />
          </div> */}
          <div className={classes.mbSpaceSlider}>
            <FormLabel className={classes.inputRangeLabel}>
              {t("findProviderPage.providerScore")}
            </FormLabel>
            <InputRange
              maxValue={10}
              minValue={0}
              value={this.state.value}
              onChange={this.handleScore}
            />
          </div>
          <div className={classes.mbSpace}>
            <Select
              label={t("findProviderPage.gender")}
              supportLabel=""
              options={[t("gender.any"), t("gender.male"), t("gender.female")]}
              elementLabelStyle={elementLabelStyle}
              elementInputStyle={elementInputStyle}
              name="gender"
              errorText=""
              value={this.state.gender}
              onChange={(e) => this.handleGenderChange(e)}
            />
          </div>
          <div className={classes.mtSpace}>
            <Dropdown.Item className={classes.dropdownStyle}>
              <Button className={classes.btnFilter} onClick={this.handleSubmit}>
                {t("balanceBilling.apply")}
              </Button>
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );

    const providersResult =
      providers && providers.length > 0 ? (
        <div className="tabsContentMain">
          {this.state.mapView && (
            <ProviderMaps
              markers={providers}
              onClick={this.resultViewHandler}
              view="list"
            />
          )}
          {this.state.cardView && (
            <FindProviderResult
              providers={providers}
              onClick={this.resultViewHandler}
              contractStatus={this.state.contractStatus}
            />
          )}
        </div>
      ) : (
        <div className="tabsContentMain">
          <div className={classes.noResults}>
            {this.props.error && this.props.errorMessage
              ? errorMessages(this.props.errorMessage)
                ? t(errorMessages(this.props.errorMessage))
                : this.props.errorMessage
              : t("findProviderPage.resultNotFound")}
          </div>
        </div>
      );
    const extendedSearchBanner = providers &&
      providers.length > 0 &&
      this.props.params.currentAttempt === 2 && (
        <div className={classes.specQuote}>
          <div className={classes.specQuoteIn}>
            <h5>
              {this.props.params.isMore
                ? t("findProviderPage.errorMsgMore")
                : t("findProviderPage.errorMsg")}{" "}
            </h5>
          </div>
        </div>
      );
    let searchView: any;
    let detailView: any;
    if (this.state.searchView) {
      searchView = (
        <div className={classes.tabContainer}>
          <Row>
            <Col lg={12}>
              <p>
                {this.props.config_values &&
                this.props.config_values.find(
                  (ele) =>
                    ele.targetPageTitle.toLowerCase() ===
                      "Find Provider".toLowerCase() &&
                    ele.element.toLowerCase() === "Search Header".toLowerCase()
                )
                  ? this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "Find Provider".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Search Header".toLowerCase()
                    )?.customValue
                    ? this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Find Provider".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Search Header".toLowerCase()
                        )
                        ?.customValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })
                    : this.props.config_values
                        .find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "Find Provider".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Search Header".toLowerCase()
                        )
                        ?.defaultValue?.split("\n")
                        .map((item, key) => {
                          return (
                            <span key={key}>
                              {item}
                              <br />
                            </span>
                          );
                        })
                  : ``}
              </p>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4} lg={3}>
              <div className={classes.cardLeft}>
                <h6 className={classes.mdTitle}>
                  {t("findProviderPage.findProvider")}
                </h6>
                <div className={classes.tabsContent}>
                  <FindProviderSearch 
                  contractStatus={this.state.contractStatus}
                  onContractStatusChanged={(value)=>this.setState({contractStatus:value})}
                  />
                </div>
              </div>
            </Col>

            <Col sm={12} md={8} lg={9}>
              <div className={classes.cardRight}>
                {providers && providers.length > 0 && (
                  <div className={classes.resLeft}>
                    <h6 className={classes.mdTitle}>
                      {t("findProviderPage.results")} ({providers.length})
                    </h6>
                  </div>
                )}
                <div className={classes.resRight}>
                  {this.state.cardView && (
                    <Button
                      className="btnLink m-r-25"
                      onClick={this.showMapView}
                    >
                      {t("findProviderPage.map")}
                      <Image src={ImgLocation} alt="ImgLocation" />
                    </Button>
                  )}
                  {this.state.mapView && (
                    <Button
                      className="btnLink m-r-25"
                      onClick={this.showCardView}
                    >
                      {t("homePage.listView")}
                      <Image src={ImgListView} alt="ImgListView" />
                    </Button>
                  )}
                  {dropdown}
                </div>
                <div className="clear"></div>
                {extendedSearchBanner}
                {providersResult}
              </div>
            </Col>
          </Row>
        </div>
      );
      detailView = null;
    }

    if (this.state.detailView) {
      detailView = (
        <div className={classes.tabContainer}>
          <ProviderDetails
            providerId={this.state.providerIdClicked}
            npi={this.state.npi}
            distance={this.state.distance}
            postalCode={this.state.postalCode}
            orgDistance={this.state.orgDistance}
            contractStatus={this.state.contractStatus}
            onClick={this.detailViewHandler}
          />
        </div>
      );
      searchView = null;
    }

    let spinner: any;
    console.log("this.props.loading", this.props.loading);
    if (this.props.loading) {
      spinner = <Spinner />;
    }

    return (
      <Fragment>
        {searchView}
        {detailView}
        {spinner}
      </Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
  loading: state.providersResult.loading,
  error: state.providersResult.error,
  providers: state.providersResult.providers,
  errorMessage: state.providersResult.errorMessage,
  params: state.searchURL.params,
  config_values: state.appConfig.config_values,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchProviders: (searchParams) =>
    dispatch(findProviderActions.fetchProviders(searchParams)),
  onAddSearchParam: (param, value) =>
    dispatch(findProviderActions.constructSearchURL(param, value)),
  onResetUnFavoriteProvider: () =>
    dispatch(findProviderActions.resetUnFavoriteProvider()),
  onResetFavoriteProvider: () =>
    dispatch(findProviderActions.resetFavoriteProvider()),
});
// export default connect(mapStateToProps, mapDispatchToProps)(FindProvider);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FindProvider));
